// src/components/Login.js
import React, { useState } from "react";
import { setToken, setUserInfo } from "../utils/auth";
import { useParams, Link, useNavigate } from "react-router-dom";
import { loginUser } from "../services/apiService";
import { toast } from "react-toastify";
import CryptoJS from "crypto-js";
import SideBar from "./SideBar";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  async function signIn(email, password) {
    try {
      let res = await loginUser(email, password);

      if (res.result == "success") {
        toast.success(res.message);

        const loginToken = res.data.token;
        setToken(loginToken);

        const userData = { role: res.data.role, email: res.data.email };
        const ENCRYPT_DECRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY;

        const encryptedData = CryptoJS.AES.encrypt(
          JSON.stringify(userData),
          ENCRYPT_DECRYPTION_KEY
        ).toString();

        setUserInfo(encryptedData);
        navigate("/dashboard");
      } else if (res.result == "error") {
        toast.error(res.message);
        return false;
      }
    } catch (error) {
      toast.error("Error fetching users:" + error);
      return false;
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Simulated login - replace with actual API call
    e.preventDefault();

    if (email == "" || password == "") {
      toast.error("Please specify email id & password !");
      return false;
    }

    signIn(email, password);
  };

  return (
    <>
      <div
        className={`container dashboard ${sidebarOpen ? "sidebar-open" : ""}`}
      >
        <nav className="navbar navbar-expand-lg navbar-light bg-white border-bottom sticky-top">
          <div className="container">
            <a href="#home" className="logo">
              Casual <span>Tech</span>
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#mainNav"
              aria-controls="mainNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={toggleSidebar}
            >
              <span className="navbar-toggler-icon"></span>
            </button>
          </div>
        </nav>

        {/* Body */}
        <div className="dashboard-body">
          {/* Sidebar */}
          <SideBar />

          {/* Main */}
          <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
              <h2>Login</h2>
            </div>

            <div className="col-sm-6 mb-3 mt-3">
              <form onSubmit={handleSubmit} className="form-control mt-3">
                <div className="form-group mb-3 mt-3">
                  <label htmlFor="exampleInputEmail1" className="mb-3 mt-3">
                    Email address
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="form-group mb-3 mt-3">
                  <label htmlFor="exampleInputPassword1" className="mb-3 mt-3">
                    Password
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="exampleInputPassword1"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <span style={{ float: "right" }} className="mb-3 mt-3">
                    <Link to="/forgot-password">Forgot password?</Link>
                  </span>
                </div>
                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
              </form>
            </div>
          </main>
        </div>

        {/* Footer */}
        <footer className="dashboard-footer">
          © 2025 Casual Tech. All rights reserved.
        </footer>
      </div>
    </>
  );
};

export default Login;
